import { ClassificationScheme } from '../../classification/classification-scheme.model';
import { Scan3dClearanceBand } from './scan-3d-clearance-band';
import { Scan3dStyleRenderingMode } from './scan-3d-style-rendering-mode';

export const DEFAULT_SCAN_3D_STYLE: Scan3dStyle = {
  renderingMode: Scan3dStyleRenderingMode.Rgb,
  blendIntensity: false,
  showEyeDomeLighting: true,
  pointBudget: 30000000,
  pointDensity: 1,
  pointSize: 2,
  classificationSchemes: [],
  intensityOffset: 0.5,
  intensityStartColor: '#07f',
  intensityEndColor: '#f70',
  clearanceDefaultTransparent: false,
  clearanceDefaultColor: '#C8A2C8',
  clearanceBands: [
    { start: -0.4, color: '#ff0000' },
    { start: 0, color: '#ff7f00' },
    { start: 0.1, color: '#ffff00' },
    { start: 0.2, color: '#00ff00' },
    { start: 0.3, color: '#0000ff' },
    { start: 0.4, color: '#000000' }, // Last color value is ignored
  ],
  elevationReference: 0,
  elevationTolerance: 1,
  elevationBandCount: 1,
  elevationOffset: 0,
  stationIconCullingDistance: 800,
  minStationIconsPerScan: 3,
};

export interface Scan3dStyle {
  renderingMode: Scan3dStyleRenderingMode;
  blendIntensity: boolean;
  showEyeDomeLighting: boolean;
  pointBudget: number;
  pointDensity: number;
  pointSize: number;
  intensityOffset: number;
  intensityStartColor: string;
  intensityEndColor: string;
  classificationSchemes: ClassificationScheme[];
  clearanceDefaultTransparent: boolean;
  clearanceDefaultColor: string;
  clearanceBands: Scan3dClearanceBand[];
  elevationReference: number;
  elevationTolerance: number;
  elevationBandCount: number;
  elevationOffset: number;
  stationIconCullingDistance: number;
  minStationIconsPerScan: number;
}
